import { registerAuthMutations } from './auth'
import { registerBookingMutations } from './booking'
import { registerUserMutations } from './user'
import { registerPresignMutations } from './presign'
import { registerStepMutations } from './step'
import { registerMyBookingMutations } from './my-booking'
import { registerPaymentMutations } from './payment'
import { registerAddOnsMutations } from './add-ons'
import { registerNotificationMutations } from './notification'
import { registerAsyncsMutations } from './asyncs'
import type { QueryClient } from '@tanstack/react-query'

export function registerDefaultMutations(queryClient: QueryClient) {
  registerAuthMutations(queryClient)
  registerBookingMutations(queryClient)
  registerUserMutations(queryClient)
  registerPresignMutations(queryClient)
  registerStepMutations(queryClient)
  registerPaymentMutations(queryClient)
  registerMyBookingMutations(queryClient)
  registerAddOnsMutations(queryClient)
  registerNotificationMutations(queryClient)
  registerAsyncsMutations(queryClient)
}
